import { Button, Modal, Title, Text, Paper, Radio, Stack, Container } from "@mantine/core";
import { IconInfoCircleFilled } from "@tabler/icons-react";
import { useSettingsStorage, useStorage } from "./ZustandState";
import { useQueryClient } from "react-query";

interface Props {
    onStart: () => void;
}

const FirstGameModal: React.FC<Props> = ({ onStart }) => {
    const showFirstGameModal = useStorage((state) => state.showFirstGameModal);
    const setShowFirstGameModal = useStorage((state) => state.setShowFirstGameModal);
    const settings = useSettingsStorage((state) => state);
    const queryClient = useQueryClient();

    return (
        <Modal
            size="md"
            withCloseButton
            opened={showFirstGameModal}
            onClose={() => {
                setShowFirstGameModal(false);
            }}
        >
            <Container p="sm">
                <Title order={2} mb="lg">
                    How it works
                </Title>
                <Paper shadow="md" p="md" withBorder>
                    <Text td="underline">Goal</Text> <Text>Play a better opening than your opponent!</Text>
                    <div className="flex items-center space-x-2 mt-6">
                        <IconInfoCircleFilled size={24} />
                        <p>Game will end after the opening</p>
                    </div>
                </Paper>
                <Radio.Group
                    name="favoriteFramework"
                    label={<Text fw="bold">Choose your start rating</Text>}
                    mt="xl"
                    value={settings.startRating.toString()}
                    onChange={(value) => settings.setSettings({ ...settings, startRating: parseInt(value) })}
                >
                    <Stack mt="xs">
                        <Radio value="700" label="700" />
                        <Radio value="1100" label="1100" />
                        <Radio value="1500" label="1500" />
                        <Radio value="1900" label="1900" />
                    </Stack>
                </Radio.Group>
                <div className="flex justify-center mt-8">
                    <Button
                        onClick={() => {
                            // queryClient.invalidateQueries({ queryKey: ["positionsData"] });
                            queryClient.invalidateQueries({ queryKey: ["positionsData"] });
                            setShowFirstGameModal(false);
                            onStart();
                        }}
                        fullWidth
                        h="3rem"
                    >
                        Let's go!
                    </Button>
                </div>
            </Container>
        </Modal>
    );
};

export default FirstGameModal;
